import { render, staticRenderFns } from "./StickersList.vue?vue&type=template&id=02ab1bdf&scoped=true&"
import script from "./StickersList.vue?vue&type=script&lang=js&"
export * from "./StickersList.vue?vue&type=script&lang=js&"
import style0 from "./StickersList.vue?vue&type=style&index=0&id=02ab1bdf&lang=scss&scoped=true&"
import style1 from "./StickersList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ab1bdf",
  null
  
)

export default component.exports